import { WebHelper } from "chipply-common";
import IEventBrandingResults from "../IEventBrandingResults";
import { IEcertCheckBalanceArgs, IEcertCheckBalanceResult } from "../IcheckEcertBalanceArgs";
import RecaptchaClient from "../verify/RecaptchaClient";
import { IEcertCodeArgs } from "../IEcertCodeArgs";
import IEventBrandingDto from "../IEventBrandingDto";

export class EcertCheckBalanceViewModel {
    public eventId: number | null = null;
    public dealerId = 0;
    public branding: IEventBrandingDto | null = null;
    public storeUrl: string | null = null;
    public ecertCodeInput: string | null = null;
    public ecertCodeResultDisplay: string | null = null;
    public ecertBalance: number | null = null;
    public ecertBalanceDisplay: string | null = null;

    public showEcertBalanceCheckResult = false;
    public loading = true;
    public checkingBalance = false;
    public showCheckBalanceErrorMessage = false;
    public errorMessage = "";

    public hideErrorMessage() {
        this.showCheckBalanceErrorMessage = false;
    }

    public async checkBalance() {
        if (
            !this.eventId ||
            !this.ecertCodeInput ||
            this.ecertCodeInput.length === 0 ||
            this.ecertCodeInput.trim().length === 0
        ) {
            return;
        }

        this.checkingBalance = true;
        this.ecertCodeResultDisplay = null;
        this.showEcertBalanceCheckResult = false;
        const baseUrl = "/api/Event/CheckEcertBalance";

        const recaptchaInfo = await this.recaptchaHandler();
        const args: IEcertCheckBalanceArgs = {
            eventId: this.eventId,
            ecertCode: this.ecertCodeInput,
            token: recaptchaInfo,
        };
        try {
            const results = await WebHelper.postJson<IEcertCheckBalanceResult>(baseUrl, args);
            this.checkingBalance = false;
            if (results.errorMessage && results.errorMessage.length > 0) {
                this.showCheckBalanceErrorMessage = true;
                this.errorMessage = results.errorMessage;
            } else {
                this.ecertBalance = results.ecertBalance.availableBalance;
                this.ecertCodeResultDisplay = args.ecertCode;
                this.ecertCodeInput = null;
                if (results.ecertBalance.displayType === 0) {
                    this.ecertBalanceDisplay = "$" + (Math.round(this.ecertBalance * 100) / 100).toFixed(2);
                } else {
                    this.ecertBalanceDisplay = `${
                        Math.round((this.ecertBalance * 100) / (results.ecertBalance.dollarValuePerPoint ?? 1)) / 100
                    } pts`;
                }
                this.errorMessage = "";
                this.showCheckBalanceErrorMessage = false;
                this.showEcertBalanceCheckResult = true;
            }
        } catch {
            this.checkingBalance = false;
            this.showCheckBalanceErrorMessage = true;
            this.errorMessage = "An error occured while get the data.";
        }
    }

    public async getBranding(): Promise<void> {
        if (!this.eventId) {
            return;
        }
        let baseUrl = "/api/Event/Branding?eventId=";
        baseUrl += encodeURIComponent(this.eventId);
        const results = (await WebHelper.getJsonData(baseUrl)) as IEventBrandingResults;
        if (results && results.dto) {
            this.branding = results.dto;
            this.storeUrl = results.dto.eventUrl;
            this.dealerId = results.dto.dealerId;
        }

        this.loading = false;
    }

    public async startShopping() {
        if (
            !this.eventId ||
            !this.ecertCodeResultDisplay ||
            this.ecertCodeResultDisplay.length === 0 ||
            this.ecertCodeResultDisplay.trim().length === 0
        ) {
            return;
        }

        this.checkingBalance = true;
        const baseUrl = "/api/Event/SaveUsedEcerts";

        const recaptchaInfo = await this.recaptchaHandler();
        const args: IEcertCodeArgs = {
            eventId: this.eventId,
            ecertCodes: [this.ecertCodeResultDisplay],
            token: recaptchaInfo,
        };
        try {
            await WebHelper.postJsonData(baseUrl, args);
            this.redirectToStorePage();
        } catch {
            this.checkingBalance = false;
            this.showCheckBalanceErrorMessage = true;
            this.errorMessage = "An error occured.";
        }
    }

    public redirectToStorePage() {
        const currentPath = window.location.pathname;
        const pathSegments = currentPath.split("/").filter(Boolean);
        if (pathSegments.length > 1 && pathSegments[pathSegments.length - 1] == "ecert-balance") {
            pathSegments.pop();
            const parentPath = "/" + pathSegments.join("/");
            window.location.href = parentPath;
        } else {
            window.location.href = "/store.aspx?eid=" + this.eventId;
        }
    }

    public closeSearchedResult() {
        this.ecertCodeInput = null;
        this.ecertCodeResultDisplay = null;
        this.ecertBalance = null;
        this.ecertBalanceDisplay = null;
        this.showEcertBalanceCheckResult = false;
    }

    protected async recaptchaHandler() {
        const recaptchaClient = new RecaptchaClient();
        const token = await recaptchaClient.execute({
            action: "submit",
        });
        return token;
    }
}
